import { Router, useRouter } from "next/router";
import useWindowSize from "react-use/lib/useWindowSize";
import BrandingText from "../../assets/Branding/BrandingText";
import Button from "../../components/Button/Button";
import ConfettiEffect from "../../components/Confetti/Confetti";
import {
  TextH1,
  TextSecondary,
} from "../../components/DesignSystem/DesignSystemText";
import { BASE_ASSET_URL } from "../../utils/asset";
import KudosPreview from "../CreateKudos/KudosPreview";
import { generateTwitterShareLink } from "./social";

const twitterIconUrl = `${BASE_ASSET_URL}/icons/twitter.svg`;
const discordIconUrl = `${BASE_ASSET_URL}/icons/discord.svg`;

const iconStyle =
  "w-11 h-11 rounded-[50%] shadow-button flex items-center justify-center bg-white px-0 py-0 min-w-0";

const ClaimDone = ({ src, nftId, username }: any) => {
  const { width, height } = useWindowSize();
  const router = useRouter();

  return (
    <>
      <ConfettiEffect />

      <div className="flex flex-col items-center text-center px-6">
        <KudosPreview src={src} />
        <div className="mb-8 mt-12">
          <TextH1 className="mb-8">Congrats, you minted a Kudos!</TextH1>
        </div>

        <div className="flex items-center gap-x-6">
          <Button
            theme="white"
            className={iconStyle}
            onClick={async () => {
              window.open(generateTwitterShareLink(username, nftId), "_blank");
            }}
          >
            <img className="h-7" src={twitterIconUrl}></img>
          </Button>
          <Button
            theme="white"
            className={iconStyle}
            onClick={async () => {
              window.open(BrandingText.DiscordInviteUrl, "_blank");
            }}
          >
            <img className="h-7" src={discordIconUrl}></img>
          </Button>
          <Button
            theme="white"
            className="h-full"
            onClick={() => {
              router.push(`/profile/${username}?tokenId=${nftId}&tab=Received`);
            }}
          >
            View details
          </Button>
        </div>
      </div>
    </>
  );
};

export default ClaimDone;
